import PropTypes from 'prop-types';
import React from 'react';
import { matchChangeHpWidget } from '@sky-it-livedata/livedata-data-cards-widgets';
import { IMatchChangeHpTemplate, MatchChangeHp } from '@sky-it-livedata/livedata-sports-design-system';

import { IWrapperModel } from '../../typings/common-types';
import { getModelFromUseService } from '../../utils/props-validator';
import { useService } from '../hooks/useService';

export interface IMatchChangeHpWrapper extends IWrapperModel<IMatchChangeHpTemplate> {}

const MatchChangeHpWrapper: React.FC<IMatchChangeHpWrapper> = ({ query, initialModel, live = true }) => {
  const { model } = useService({
    live,
    query,
    initialValue: initialModel,
    widget: matchChangeHpWidget,
  });

  const componentModel: IMatchChangeHpTemplate = getModelFromUseService(model);
  // console.log('MatchChangeHpWrapper', { componentModel }); // For TRACKING-DATA debug

  return <MatchChangeHp {...componentModel} />;
};

MatchChangeHpWrapper.propTypes = {
  initialModel: PropTypes.any.isRequired,
  live: PropTypes.bool,
  query: PropTypes.object.isRequired,
};

MatchChangeHpWrapper.defaultProps = {
  live: true,
};

export default MatchChangeHpWrapper;
